import { useContext } from 'react';
import { EmbedModeContext } from './services/provider/index.tsx';

export const useIsEmbedMode = () => useContext(EmbedModeContext);

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { EmbedModeProvider, EmbedModeContext } from './services/provider/index';
